import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>
                                                Giving people time and space to carry out activities which may
                                                be a stretch (and that you think
                                                you can do in half the time) can often work out for the best in
                                                the longer term through individual
                                                development. This tool is all about<span
                                                className="brown brownbold"> how to delegate </span>and will
                                                help you to decide what kind of tasks
                                                may be delegated to your team, how to structure tasks to meet
                                                organisational goals, and ensure
                                                that professional development occurs in tandem.
                                            </p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>DELEGATION AND THE PSYCHOLOGICAL CONTRACT
                                            </div>
                                            <p>So many of us complain that we’ve got too much to do, both at
                                                work and elsewhere, but carry on
                                                chasing our tails, day after day. It’s either because we don’t
                                                trust anyone else to do things properly,
                                                or we think we might be suspected of not coping or ‘passing the
                                                buck’. Often, too, people make
                                                a virtue of hectic busyness – as if it demonstrates
                                                indispensability, success – or just that their life
                                                is full of excitement!</p>
                                            <p>Effective delegation, however, not only saves time but also
                                                speeds and increases the chance of
                                                successful outcomes. Indeed, it will also teach and motivate
                                                others. Most of the difficulties some of
                                                us experience are to do with the manner in which we delegate, or
                                                because what we say is incomplete
                                                or unclear. Stop, and consider for a moment or two, the fact
                                                that people are usually willing to help
                                                each other when asked – so why do we avoid delegating, and what
                                                goes wrong when we try to?</p>
                                            <div className="border_subtitle">The role of ‘psychological
                                                contracts’<a className="superscripttext boldlink"
                                                             href="further_info.php?course=300"><sup>3</sup></a> in
                                                delegation
                                            </div>

                                            <p>A formal contract is a written exchange of promises, but verbal
                                                agreements can be just as
                                                legally binding.</p>

                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                <p>The psychological contract refers to these same mutual
                                                    beliefs, perceptions, and informal
                                                    obligations between an employer and employee.</p>
                                            </div>
                                            <p>What we mean by ‘psychological contract’ is the implicit (not
                                                written or spoken) understanding
                                                between ourselves and the person with whom we make an agreement
                                                – or to whom we delegate
                                                a task. The relevance of it is that the parties involved may
                                                have different ideas about what that is
                                                and, therefore, about the way in which the agreement should be
                                                upheld or carried out.</p>

                                            <p>You can see why people often unfairly accuse each other of not
                                                sticking to an agreement – and
                                                how often, too, you might complain that someone to whom you
                                                delegated something hasn’t done
                                                it properly. Imagine, for example, agreeing with your line
                                                manager to spend a reasonable amount
                                                of time training and developing a new recruit. Now, imagine the
                                                kind of problems that would occur
                                                if you both interpreted ‘reasonable amount of time’ and
                                                ‘training and developing’ differently?</p>

                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                <p>When we are explaining or delegating something that’s
                                                    familiar or readily understood by
                                                    ourselves, it’s easy to assume we’ve made things clear –
                                                    only to discover we didn’t. Effective
                                                    delegating is largely about the clarity of your instruction,
                                                    and the more responsibilities you
                                                    have, the more important it is to make sure people
                                                    understand what you expect of them.</p>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>WHAT TO DELEGATE?
                                            </div>
                                            <p>It may sound obvious, but make sure you’re not delegating things
                                                unnecessarily – things which
                                                are redundant, for example, and could be eliminated from your
                                                task list altogether. Or, are you
                                                delegating tasks for which you are not personally
                                                responsible?</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>

                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}